import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
export var FormFieldHelperText = function (_a) {
    var children = _a.children, id = _a.id, _b = _a.type, type = _b === void 0 ? 'normal' : _b;
    return (React.createElement(SRoot, { id: id, "$type": type }, children));
};
var SRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 0.75rem;\n  color: ", ";\n  margin-top: 4px;\n"], ["\n  font-size: 0.75rem;\n  color: ",
    ";\n  margin-top: 4px;\n"])), function (_a) {
    var theme = _a.theme, $type = _a.$type;
    switch ($type) {
        case 'error':
            return theme.velocity.styling.system.error.main;
        case 'success':
            return theme.velocity.styling.system.success.main;
        case 'warning':
        default:
            return '#000'; // todo: we don't have it in theme yet
    }
});
var templateObject_1;
//# sourceMappingURL=FormFieldHelperText.js.map